var map = {
	"./de/btn-detail.png": "Ybc7",
	"./en/btn-detail.png": "8glx",
	"./es/btn-detail.png": "4rkH",
	"./fr/btn-detail.png": "mlra",
	"./ja/btn-detail.png": "gYc6",
	"./ko/btn-detail.png": "thY0",
	"./pt/btn-detail.png": "NCT7",
	"./ru/btn-detail.png": "KyW4",
	"./th/btn-detail.png": "NO8c",
	"./zh-Hant/btn-detail.png": "37d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rmS1";